<template lang="pug">
    modal(ref="modalDeletePlanogram" id="modalDeletePlanogram" )
        template(slot="title") Delete Overview
        template(slot="body")
            div
                form(id="import-mapper")
                    div.row-col.m-t-md
                        div.col-xs-6.p-a-sm
                            span._500.m-l-sm Planogram Quantity
                            v-loading(loader="get-planogram-count")
                                span._500.m-l-sm.block(style="color: #1F9A92")  {{ planogram.total_planogram }} Planograms will be deleted
                        div.col-xs-6.p-a-sm
                            .form-group
                                span._500.m-l-sm Description
                                input.form-control(
                                    v-validate="'required'",
                                    v-model="description",
                                    :disabled="onLoading('get-planogram-count')",
                                    type="text",
                                    class="form-control",
                                    name="description",
                                    placeholder="Required",
                                )
                    div.row-col.m-b-md
                        div.col-xs-6.p-a-sm
                            span._500.m-l-sm Total Product Line
                            v-loading(loader="get-planogram-count")
                                span._500.m-l-sm.block(style="color: #1F9A92")  {{ planogram.total_lines }} lines will be removed
                        div.col-xs-6.p-a-sm
                            span._500.m-l-sm Effective At
                            datetimepicker-input( :disabled="onLoading('get-planogram-count')", v-model="effectiveAt")
        template(slot="footer")
            button.btn.btn-fw.primary(
                @click="proceedDelete",
                :disabled="description === ''"
            )
                v-loading(loader="delete-planogram") Delete

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DatetimepickerInput from '@js/components/datetimepicker/datetimepicker.vue';
import { Event } from '../../../event-bus';
export default {
    components: {
        DatetimepickerInput,
    },
    data() {
        return {
            description: '',
            effectiveAt: null,
            id: [],
        };
    },

    computed: {
        ...mapGetters({
            planogram: 'planogram/countPlanogramProduct',
        }),
    },

    mounted() {
        this.$on('show', e => {
            this.$refs.modalDeletePlanogram.$emit('show');
            this.id = e;
        });
    },

    methods: {
        hideModal() {
            $('#modalDeletePlanogram').modal('hide');
        },
        clearInputPlanogramData() {
            this.description = '';
            this.effectiveAt = null;
        },
        async proceedDelete() {
            let params = {
                ids: this.id,
                description: this.description,
                effective_at:
                    this.effectiveAt !== null && this.effectiveAt !== ''
                        ? this.effectiveAt.format('YYYY-MM-DD HH:mm:ss')
                        : null,
            };
            this.toggleLoader({ name: 'delete-planogram' });
            await axios.delete(
                Laroute.route('franchise.inventory.planogram.delete'),
                { params },
            );
            this.toggleLoader({ name: 'delete-planogram', start: false });
            Event.$emit('import-completed');
            this.clearInputPlanogramData();
            this.hideModal();
        },
        ...mapActions('planogram', ['toggleLoader']),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/planogram/delete-planogram.vue